import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { getRentalPortalListingsPage } from '../../../../../api'
import { EMPTY_LIST } from '../../../../../constants/common'
import { useSelection } from '../../../../../hooks'
import { useLocationPagination } from '../../../../Pagination'
import {
  getRentalPortalArchiveListingsParams,
  getRentalPortalArchivePagination,
  toRentalPortalArchiveItem,
} from '../../RentalPortalArchive.utils'

export function useRentalPortalArchiveTable() {
  const { t } = useTranslation()

  const { pagination, setPagination } = useLocationPagination()

  const [listings, setListings] = useState(EMPTY_LIST)
  const [serverError, setServerError] = useState(null)

  const [isInitiated, setInitiated] = useState(false)
  const [isRefreshing, setRefreshing] = useState(false)

  const loadIdRef = useRef(0)

  const pageScrollWrapperRef = useRef(null)

  const items = listings.map(listing =>
    toRentalPortalArchiveItem({ listing, t })
  )

  const selection = useSelection({ data: { items }, pagination })

  async function handleLoadItems() {
    loadIdRef.current += 1

    const loadId = loadIdRef.current

    return getRentalPortalListingsPage(
      getRentalPortalArchiveListingsParams(pagination.page)
    )
      .then(({ data }) => {
        if (loadIdRef.current === loadId) {
          const nextPagination = getRentalPortalArchivePagination(
            pagination,
            data.pagination
          )

          setPagination(nextPagination)

          if (nextPagination.page === pagination.page) {
            setListings(data.items)
            setServerError(null)
            setInitiated(true)
          }
        }
      })
      .catch(error => {
        if (loadIdRef.current === loadId) {
          setServerError(error)
          setInitiated(true)
        }
      })
  }

  async function handleRefresh() {
    selection.handleCleanSelection()

    setRefreshing(true)

    return handleLoadItems().finally(() => {
      setRefreshing(false)
    })
  }

  useEffect(() => {
    handleLoadItems()
  }, [pagination.page])

  return {
    ...selection,
    handleRefresh,
    handleSetPagination: setPagination,
    isLoading: !isInitiated,
    isRefetching: isRefreshing,
    items,
    pageScrollWrapperRef,
    pagination,
    serverError,
  }
}
